import { datadogLogs } from '@datadog/browser-logs'

datadogLogs.init({
  clientToken: 'pub73f434d3eb8940fec2ae5297b7be65f6',
  site: 'us5.datadoghq.com',
  service:
    process.env.NODE_ENV === 'production'
      ? 'redwood-client'
      : 'redwood-client-local-dev',
  env: process.env.DEPLOYMENT_ENVIRONMENT,
  forwardConsoleLogs: ['error'],
})
